import { FC } from 'react';

import { containerQueries } from '@phoenix/design-system/frontend/ui/breakpoints/breakpoints';
import { ProductCategory } from '@phoenix/team-m/dashboard/frontend/util/product/product.model';
import { getProductCategoryTranslation } from '@phoenix/team-m/my-tool-shed/frontend/util/master-data';

import { Image } from './image';

interface ProductDetailsProps {
  imageSrc: string;
  productName: string;
  productCategory?: ProductCategory;
}

export const ProductDetails: FC<ProductDetailsProps> = ({ imageSrc, productName, productCategory }) => {
  return (
    <div className="flex items-center">
      <div className="relative aspect-[16/9] h-20 min-w-[150px]">
        <Image
          src={imageSrc}
          fill
          className="object-contain"
          alt={productCategory?.name ?? ''}
          sizes={`(max-width: ${containerQueries.desktop}) 80vw, 20vw`}
        />
      </div>
      <div className="flex flex-col gap-y-2 p-4">
        <span className="stihl-text-body-sm-reg">{getProductCategoryTranslation(productCategory)}</span>
        <span className="stihl-text-body-default-bold">{productName}</span>
      </div>
    </div>
  );
};
